module.exports = __webpack_public_path__ + "media/images/featured-products/pension-gap-planner-80e1425443fdb3a99d360fbdcb344df7.svg";